// api/authAPI.ts
import qs from "qs";
import apiClient from './apiClient';
import { User } from '../types/User';
import Constants from "../constants";
import {GetUserMannerAPIResInterface} from "../types/GetUserMannerAPIRes.interface";

const basePath = '/api/admin/common/user';

const fetchUserAPI = async () : Promise<User> => {
  const response = await apiClient.get('/api/user');
  return response.data.user;
}

const fetchUserInfoAPI = async (userId: string) => {
	const response = await apiClient.get(`/api/admin/common/user/${userId}`);
	return response.data;
}

const getUserListAPI = async () => {
  const path = `${basePath}/list`;

  const response = await apiClient.get(path);
  return response.data;
}

const searchUserAPI = async (str: string) => {
  const path = `${basePath}/search2`;
  const query = `str=${str}`;

  const response = await apiClient.get(`${path}?${query}`);
  return response.data;
}

const searchUserByPhoneNumAPI = async (phoneNum: string) => {
  const path = `${basePath}/searchByPhoneNum`;
  const query = `phoneNum=${phoneNum}`;
  const response = await apiClient.get(`${path}?${query}`);
  return response.data;
}

const getRoleAPI = async () : Promise<string[] | undefined> => {
  const path = `${basePath}/role`;
  try {
    const response = await apiClient.get(path);
    return response.data;
  } catch (e) {
    console.error(e);
  }
}

const fetchUserListAPI = async ({
	                            id,
	                            page,
	                            limit = Constants.PAGE_SIZE,
	                            name,
	                            phoneNum,
	                            email,
															isVerified,
                            }: {
	id?: string;
	page: number;
	limit: number;
	name?: string;
	phoneNum?: string;
	email?: string;
	isVerified?: boolean;
}): Promise<User[]> => {
	const offset = (page - 1) * limit;
	const query = qs.stringify({
		id,
		offset,
		limit,
		name,
		phoneNum,
		email,
		isVerified,
	});
	const response = await apiClient.get(`/api/admin/common/user/list?${query}`);
	return response.data;
};


// user, member, user_car, member_car 등 한번에 fetch
const fetchUserDataAPI = async (userId: string) => {
	const res = await apiClient.get(`/api/admin/common/user/${userId}`);
	return res.data;
};

const fetchSubscriptionAPI = async (userId: string) => {
	const res = await apiClient.get(`/api/admin/business/user/${userId}/subscription`);
	return res.data;
}

const fetchSubscriptionHistoryAPI = async (userId: string) => {
	const res = await apiClient.get(`/api/admin/business/user/${userId}/subscriptionHistory`);
	return res.data;
}

const fetchUserMannerAPI = async (userId: string): Promise<GetUserMannerAPIResInterface> => {
	const res = await apiClient.get(`/api/user/manner/${userId}`);
	return res.data;
}

const resetUserMannerAPI = async (userId: string) => {
	const res = await apiClient.get(`/api/user/manner/${userId}/reset`);
	return res.data;
};


const userAPI = {
  getUserListAPI,
  fetchUserAPI,
	fetchUserInfoAPI,
  searchUserAPI,
  searchUserByPhoneNumAPI,
  getRoleAPI,
	fetchUserListAPI,
	fetchUserDataAPI,
	fetchSubscriptionAPI,
	fetchSubscriptionHistoryAPI,
	fetchUserMannerAPI,
	resetUserMannerAPI,
}

export default userAPI;

